import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `vehicle-type`);
        return response;
    } catch (e) { }
}

export async function vehicleTypeAdd(newDetails: any) {
    try {
        const response = await apiPost('core', `vehicle-type`, newDetails);
        return response;
    } catch (e) { }
}

export async function vehicleTypeUpdate(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `vehicle-type/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removeVehicleType(id: any) {
    try {

        return await apiDelete('core', `vehicle-type/${id}`);
    } catch (e) { }
}